import React from 'react';
import { FormattedMessage } from 'react-intl';
import { position, rem } from 'polished';
import styled from 'styled-components';

import { wrapWithStore } from 'helpers/store';
import { breakpoints } from 'helpers/styles/constants';
import { container } from 'helpers/styles/mixins';
import IconEmail from 'components/Icons/HowItWorks/IconEmail';
import IconInPersonMeetings from 'components/Icons/HowItWorks/IconInPersonMeetings';
import IconOnlineForms from 'components/Icons/HowItWorks/IconOnlineForms';
import IconOnlineMeetings from 'components/Icons/HowItWorks/IconOnlineMeetings';
import IconPost from 'components/Icons/HowItWorks/IconPost';
import IconTelephoneMeetings from 'components/Icons/HowItWorks/IconTelephoneMeetings';
import { MainTitles, SubTitle, Title } from 'components/MainTitles/MainTitles';
import LandingApp from 'LandingApp';

import SectionItem from '../components/HowItWorks/SectionItem/SectionItem';

const Section = styled.div`
  position: relative;
  padding-left: ${rem(40)};

  @media ${breakpoints.smUp} {
    padding: 0 ${rem(80)};
  }

  @media ${breakpoints.mdUp} {
    padding: 0 ${rem(200)};
  }

  &::before {
    ${position('absolute', 0, null, 0, 0)};
    content: '';
    border-left: 2px dashed ${({ theme }) => theme.colors.main};
    opacity: 0.3;

    @media ${breakpoints.smUp} {
      left: ${rem(30)};
    }

    @media ${breakpoints.mdUp} {
      left: ${rem(100)};
    }
  }
`;

const Wrapper = styled.div`
  ${container()};
  margin-top: ${rem(60)};
  margin-bottom: ${rem(90)};

  @media ${breakpoints.smUp} {
    margin-top: ${rem(100)};
    margin-bottom: ${rem(140)};
  }
`;

const items = [
  { icon: <IconInPersonMeetings />, hasSubtitle: true },
  { icon: <IconTelephoneMeetings />, hasSubtitle: true },
  { icon: <IconEmail />, hasSubtitle: true },
  { icon: <IconOnlineForms />, hasSubtitle: true },
  { icon: <IconOnlineMeetings />, hasSubtitle: true },
  { icon: <IconPost />, hasSubtitle: true },
];

function HowWeCommunicatePage() {
  return (
    <LandingApp>
      <MainTitles>
        <Title>
          <FormattedMessage id="howWeCommunicate.title" />
        </Title>

        <SubTitle>
          <FormattedMessage id="howWeCommunicate.summary" />
        </SubTitle>
      </MainTitles>

      <Wrapper>
        <Section>
          {items.map(({ icon, hasSubtitle }, index) => (
            <SectionItem
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              icon={icon}
              index={index + 1}
              hasSubtitle={hasSubtitle}
              translationKey="howWeCommunicate"
            />
          ))}
        </Section>
      </Wrapper>
    </LandingApp>
  );
}

export { HowWeCommunicatePage as HowWeCommunicatePageUnwrapped };

export default wrapWithStore(HowWeCommunicatePage);
